export default function Logo() {
  return (
    <a href="/#top" className="flex items-center relative group">
      <div className="relative">
        <img 
          src={process.env.PUBLIC_URL + '/bg_removed_dark_text.png'} 
          alt="Emberon Labs" 
          className="h-11 w-auto object-contain relative z-10 transition-transform duration-300 group-hover:scale-[1.03]"
        />
        <span 
          className="absolute inset-0 rounded-full blur-xl opacity-20 group-hover:opacity-40 transition-opacity duration-300 z-0 pointer-events-none" 
          style={{ background: 'var(--lead-soft)', filter: 'blur(16px)' }}
        ></span>
      </div>
    </a>
  );
}

